import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LocalDataService from '../../api/LocalDataService';
import { useAuth } from '../../components/auth/AuthContext';
import LoginMethods from './LoginMethods';
import './login.css';

function Login() {
  const history = useHistory();
  const location = useLocation();
  const { completeLogin: updateAuthenticatedUser } = useAuth();
  const context = LocalDataService.resolveReferralParams(location.search || '');
  const redirectPath = context.redirectPath || '/';

  const completeLogin = (userInfo) => {
    updateAuthenticatedUser(userInfo);
    history.replace(redirectPath);
  };

  useEffect(() => {
    document.title = '登录 · 剧查查超级工厂';
    if (LocalDataService.load_user_data()?.token) {
      history.replace(redirectPath);
      return undefined;
    }

    return () => {
      document.title = '剧查查超级工厂';
    };
  }, []);

  return (
    <main className="canvas-login-page">
      <div className="canvas-login-grid" aria-hidden="true" />
      <section className="canvas-login-intro">
        <div className="canvas-login-kicker"><span>剧查查</span> SUPER FACTORY / 01</div>
        <h1>把灵感变成<br /><em>可运行的画布</em></h1>
        <p>连接图像、视频、声音与文字模型，在一张无限画布上完成从想法到作品的全过程。</p>
        <div className="canvas-login-proof">
          <span><b>∞</b> 无限编排</span>
          <span><b>30+</b> 创作节点</span>
          <span><b>1</b> 项目空间</span>
        </div>
      </section>

      <section className="canvas-login-panel" aria-label="登录剧查查超级工厂">
        <LoginMethods redirectPath={redirectPath} onSuccess={completeLogin} />
      </section>
    </main>
  );
}

export default Login;
